import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import { AppBar, Box, IconButton, Toolbar, useTheme } from "@mui/material";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import Logo from "../misc/Logo";

interface MinimalHeaderProps {
  onDrawerToggle: () => void;
  isDrawerOpen: boolean;
}

export default function MinimalHeader({
  onDrawerToggle,
  isDrawerOpen,
}: MinimalHeaderProps) {
  const theme = useTheme();
  const navigate = useNavigate();
  return (
    <AppBar
      position="fixed"
      sx={{
        bgcolor: "background.paper",
        boxShadow: 1,
        zIndex: theme.zIndex.drawer + 2,
      }}
    >
      <Toolbar variant="dense">
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexGrow: { xs: 1, md: 0 },
          }}
        >
          <Logo navigate={navigate} path={"/app"} />
        </Box>
        <motion.div
          style={{
            marginLeft: "auto",
            position: "relative",
            width: 48,
            height: 48,
          }}
        >
          <motion.div
            animate={{ rotate: isDrawerOpen ? 90 : 0 }}
            transition={{ duration: 0.3 }}
          >
            <IconButton
              onClick={onDrawerToggle}
              size="large"
              edge="end"
              color="primary"
              aria-label={isDrawerOpen ? "fermer le menu" : "ouvrir le menu"}
            >
              {window.location.pathname !== "/app" &&
                (isDrawerOpen ? <CloseIcon /> : <MenuIcon />)}
            </IconButton>
          </motion.div>
        </motion.div>
      </Toolbar>
    </AppBar>
  );
}
